import { Map } from 'mapbox-gl';
import { mapColorPalette } from "../../../../../constants/Map";
import { ZoomLevel } from "../../../../../store/wellWaterSystem";
import { ICountyWellWaterSystemResult } from '../../../../../types';

export const updateCountyStyles = (
  mapRef: React.RefObject<Map>,
  countyHousingUnits: ICountyWellWaterSystemResult[] | null,
  countyHousingUnitsRef: React.MutableRefObject<ICountyWellWaterSystemResult[] | null>,
  zoomLevel: ZoomLevel | string,
  prevSelectedCode: React.MutableRefObject<any>,
): void => {
  if (!Array.isArray(countyHousingUnits) || zoomLevel !== ZoomLevel.COUNTY) {
    return;
  }

  countyHousingUnitsRef.current = countyHousingUnits;

  const applyStyles = () => {
    if (!mapRef.current) return;

    const sortedCounties = [...countyHousingUnits].sort((a, b) => b.totalHousingUnits - a.totalHousingUnits);
    
    const countyColorMapping = sortedCounties.reduce<Record<string, string>>((acc, county, index) => {
      if (!county?.county_name) return acc;
      
      if (county.totalHousingUnits === 0) {
        acc[county.county_name] = '#FFFFFF';
        return acc;
      }

      const countiesPerGroup = Math.ceil(sortedCounties.filter(c => c.totalHousingUnits > 0).length / mapColorPalette.length);
      
      const colorIndex = Math.min(
        Math.floor(index / countiesPerGroup),
        mapColorPalette.length - 1
      );
      
      acc[county.county_name] = mapColorPalette[colorIndex];
      return acc;
    }, {});

    const colorEntries = Object.entries(countyColorMapping).filter(entry => entry[0] && entry[1]);

    if (colorEntries.length === 0) {
      mapRef.current.setPaintProperty('main', 'fill-color', '#FFFFFF');
      return;
    }

    const matchExpression: mapboxgl.ExpressionSpecification = [
      'match',
      ['get', 'name'],
      ...colorEntries.map(([county, color]) => [county, color]).flat(),
      '#FFFFFF'
    ];

    mapRef.current.setPaintProperty('main', 'fill-color', matchExpression);
  };

if (mapRef.current?.isStyleLoaded()) {        
    applyStyles();
    return;
  } else {
    // handleCountyZoom(mapRef.current, prevSelectedCode, countyHousingUnitsRef);
  }

  mapRef.current?.once('style.load', () => {
    applyStyles();
  });
};
